import React, { Component } from 'react'
import Footer from '../../Component/Footer'
import Header from '../../Component/Header'
import Menu from '../../Component/Menu'
import InvoiceTable from './Invoicetable'

export default class InvoiceTableWrapper extends Component {
    render() {
        return (
            <div>
                <Header />
                 <Menu/>
                <>
              <div className="content-wrapper">
              <InvoiceTable/>

              </div>
              </>
              <Footer/>

            </div>
        )
    }
}
